module.exports = __webpack_public_path__ + "static/img/saimenInstallForMac_pic9.173c30a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForMac/saimenInstallForMac_pic9.png
// module id = 575
// module chunks = 1